export default __webpack_public_path__ + "static/media/something-wrong.f495992e.svg";